import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ModalUpgrade } from './ModalUpgrade';
export const GrainModalUpgrade = createComponent({
    tagName: 'grain-modal-upgrade',
    elementClass: ModalUpgrade,
    react: React,
    events: {
        onOpen: 'open',
        onClose: 'close',
    },
});
